/**
 * 실행계획 보관소 API — **AI 와 무관하다.**
 *
 * `assistantClient.js` 에 두지 않는 이유: 그 파일은 AI 제외 빌드에서 공통 패키지를 `null` 로
 * 떨어뜨리는 갈래를 갖고 있다. 보관소는 그 빌드에서도 온전히 돌아야 하므로 서비스 파일을 따로 둔다.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/plan-archive`;

/** 저장 — `{ title, kind, summary, verdict, source, threadId, connectionId, items[] }` */
export async function savePlanArchive(payload) {
    const { data } = await axios.post(ROOT, payload);
    return data;
}

/** 목록 — 계획 원문은 오지 않는다(길이만) */
export async function listPlanArchive({ q = '', limit, offset } = {}) {
    const { data } = await axios.get(ROOT, { params: { q, limit, offset } });
    return data;
}

/**
 * 한 건 — 계획 원문 포함.
 * **연결 id 를 질의로 보내지 않는다.** 서버 초크포인트가 그것을 보고 접근 검사를 도는데,
 * 보관물의 연결은 이미 지워졌을 수 있어 자기가 저장한 것을 못 열게 된다.
 */
export async function getPlanArchive(id) {
    const { data } = await axios.get(`${ROOT}/${encodeURIComponent(id)}`);
    return data;
}

export async function renamePlanArchive(id, { title, note }) {
    const { data } = await axios.patch(`${ROOT}/${encodeURIComponent(id)}`, { title, note });
    return data;
}

export async function deletePlanArchive(id) {
    const { data } = await axios.delete(`${ROOT}/${encodeURIComponent(id)}`);
    return data;
}

export default { savePlanArchive, listPlanArchive, getPlanArchive, renamePlanArchive, deletePlanArchive };
